var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 21,
    viewBox: "0 0 80 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 14C35.3764 14.8206 40 21 40 21V7C40 7 27.7238 6.72454 20 5.5C11.9995 4.23159 0 0 0 0C0 0 15 11 31 14Z",
    fill: "#BAB6D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C24.3764 8.82057 40 9.5 40 9.5V7C40 7 27.7238 6.72454 20 5.5C11.9995 4.23159 0 0 0 0C0 0 4 5 20 8Z",
    fill: "#CAD3ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 14C44.6236 14.8206 40 21 40 21V7C40 7 52.2762 6.72454 60 5.5C68.0005 4.23159 80 0 80 0C80 0 65 11 49 14Z",
    fill: "#70598E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8C55.6236 8.82057 40 9.5 40 9.5V7C40 7 52.2762 6.72454 60 5.5C68.0005 4.23159 80 0 80 0C80 0 76 5 60 8Z",
    fill: "#CAD3ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C24.3764 8.82057 40 9.5 40 9.5V8.5C40 8.5 27.7238 8.22454 20 7C16.6434 6.46784 12.0829 5.3505 8.5 4C2.17228 1.61491 0 0 0 0C0 0 4 5 20 8Z",
    fill: "#EDF2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8C55.6236 8.82057 40 9.5 40 9.5V8.5C40 8.5 52.2762 8.22454 60 7C63.3566 6.46784 67.9171 5.3505 71.5 4C77.8277 1.61491 80 0 80 0C80 0 76 5 60 8Z",
    fill: "#E3E2FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownSmall);
export default __webpack_public_path__ + "static/media/scroll-down-small.1a54473a082baf138815024b958e2f1a.svg";
export { ForwardRef as ReactComponent };